import { defineComponent } from 'vue';
// eslint-disable-next-line no-restricted-imports -- Legacy
import Icon from '@common/layout/Icon.vue';
import BootstrapVariant from '@vendor/bootstrap/BootstrapVariant';
import { translator } from '@common/mixins';
export default defineComponent({
    name: 'Badge',
    compatConfig: {
        MODE: 3,
    },
    components: {
        Icon,
    },
    mixins: [translator],
    props: {
        text: {
            type: String,
            required: true,
        },
        color: {
            type: String,
        },
        pill: {
            type: Boolean,
            default: false,
        },
        canBeDeleted: {
            type: Boolean,
            default: false,
        },
        uncapitalize: {
            type: Boolean,
            default: false,
        },
        iconName: {
            type: String,
            default: null,
        },
        iconTitle: {
            type: String,
            default: '',
        },
    },
    emits: ['delete'],
    data() {
        return {
            BootstrapVariant,
        };
    },
});
